// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__pC0nh","fullwindow":"BBHTML_fullwindow__1e7FK"};